import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import './ShopingCart.css';
// import { Col, Container, Row, Label, Input } from 'reactstrap';
import Header from '../components/Header';
import MenuHeader from '../components/MenuHeader';
import Footer from '../components/Footer';
import {
	Col,
	Container,
	Row,
	Label,
	Input,
	Table,
	InputGroup,
	InputGroupText,
} from 'reactstrap';

const ShoppingCart = () => {
	const [shoppingCart, setShoppingCart] = useState([]);
	const [valuesClicked, setValuesClicked] = useState([
		{ id: '', plusClicked: 0, minusClicked: 0 },
	]);
	const history = useHistory();
	const total = () => {
		let totalValue = 0;
		if (shoppingCart.length) {
			shoppingCart.map(
				sc => (totalValue += sc.price * (sc.value + timeClicked(sc.id)))
			);
		}
		return totalValue;
	};
	const totalAfter = () => {
		let totalValue = 0;
		if (shoppingCart.length) {
			shoppingCart.map(sc => (totalValue += sc.price * sc.value));
		}
		return totalValue;
	};
	const timeClicked = id => {
		let totalValue = 0;
		let totalTimeClicked = valuesClicked.find(vc => vc.id == id);
		if (totalTimeClicked) {
			totalValue +=
				totalTimeClicked.plusClicked + totalTimeClicked.minusClicked;
			console.log('totalClicked', totalValue);
			return totalValue;
		} else {
			return totalValue;
		}
	};

	useEffect(() => {
		const data = JSON.parse(localStorage.getItem('cart'));
		if (data) {
			setShoppingCart(data);
		}
	}, [shoppingCart]);

	return (
		<>
			<Header />
			<MenuHeader />
			{/* <div className='container-fluid col-11 mt-4 mx-auto'> */}
			<div className='container-fluid col-11 mt-5 mx-auto'>
				<h3 className='shopingCart_title'>
					Shopping cart{' '}
					<span className='shopingCart_span'>
						({shoppingCart.length})
					</span>
				</h3>
			</div>
			<div className='container-fluid'>
				<Container>
					<Row>
						<Col sm='9' className='mt-5'>
							<Table>
								<thead>
									<tr>
										<th></th>
										<th></th>
										<th className='table_head'>
											Product name
										</th>
										<th className='table_head'>
											Unit price
										</th>
										<th className='table_head'>Quantity</th>
										<th className='subtotal'>Subtotal</th>
									</tr>
								</thead>
								<tbody>
									{shoppingCart.length ? (
										shoppingCart.map((sp, index) => (
											<tr key={sp.id}>
												<th
													onClick={() => {
														let duplicate =
															shoppingCart;
														duplicate.splice(
															index,
															index + 1
														);
														setShoppingCart(
															duplicate
														);
														localStorage.setItem(
															'cart',
															JSON.stringify(
																duplicate
															)
														);
													}}
													style={{
														cursor: 'pointer',
													}}
													scope='row'
												>
													x
												</th>
												<td>
													<img
														width='80'
														className='img-fluid'
														src={sp.imageURLID}
														alt='product'
													/>
												</td>
												<td className='product_name'>
													{sp.name}
												</td>
												<td className='unit_price'>
													${sp.price}
												</td>
												<td>
													<InputGroup className='rounded'>
														<InputGroupText
															style={{
																backgroundColor:
																	'#F0F2F5',
																cursor: 'pointer',
															}}
															onClick={() => {
																let duplicate =
																	valuesClicked.find(
																		vc =>
																			vc.id ==
																			sp.id
																	);
																let duplucateIndex =
																	valuesClicked.findIndex(
																		vc =>
																			vc.id ==
																			sp.id
																	);
																console.log(
																	duplicate
																);
																if (duplicate) {
																	let allClicked =
																		valuesClicked;
																	allClicked[
																		duplucateIndex
																	].plusClicked += 1;
																	setValuesClicked(
																		allClicked
																	);
																} else {
																	setValuesClicked(
																		[
																			...valuesClicked,
																			{
																				id: sp.id,
																				plusClicked: 1,
																				minusClicked: 0,
																			},
																		]
																	);
																}
															}}
															className='border-0'
														>
															<i className='fas fa-plus' />
														</InputGroupText>
														<Input
															style={{
																backgroundColor:
																	'#F0F2F5',
																maxWidth:
																	'40px',
															}}
															value={
																sp.value +
																timeClicked(
																	sp.id
																)
															}
															className=' border-0'
														/>
														<InputGroupText
															style={{
																backgroundColor:
																	'#F0F2F5',
																cursor: 'pointer',
															}}
															onClick={() => {
																let duplicate =
																	valuesClicked.find(
																		vc =>
																			vc.id ==
																			sp.id
																	);
																let duplucateIndex =
																	valuesClicked.findIndex(
																		vc =>
																			vc.id ==
																			sp.id
																	);
																if (duplicate) {
																	let allClicked =
																		valuesClicked;
																	allClicked[
																		duplucateIndex
																	].minusClicked -= 1;
																	setValuesClicked(
																		allClicked
																	);
																} else {
																	setValuesClicked(
																		[
																			...valuesClicked,
																			{
																				id: sp.id,
																				plusClicked: 0,
																				minusClicked:
																					-1,
																			},
																		]
																	);
																}
															}}
															className='border-0'
														>
															<i className='fas fa-minus' />
														</InputGroupText>
													</InputGroup>
												</td>
												<td className='unit_price'>
													$
													{sp.price *
														(sp.value +
															timeClicked(sp.id))}
												</td>
											</tr>
										))
									) : (
										<tr>
											<td>No Products in Cart</td>
										</tr>
									)}
								</tbody>
							</Table>
							<Row className='mt-5'>
								<Input
									style={{
										backgroundColor: '#F0F2F5',
									}}
									className='coupan_code mt-1'
									type='text'
									placeholder='Coupan Code'
								/>
								<button className='apply_coupan ml-3'>
									Apply Coupan
								</button>
								<button className='clear_all'>Clear All</button>
								<button className='apply_coupan ml-3'>
									Update Cart
								</button>
							</Row>
						</Col>
						<Col sm='3'>
							<div className='cart_total'>Cart totals</div>
							<Row>
								<Col>
									<div className='cart_total ml-3'>
										Subtotal
									</div>
								</Col>
								<Col>
									<div className='cart_total1 ml-3'>
										${total()}
									</div>
								</Col>
							</Row>
							<div className='cart_total ml-3'>Shipping</div>
							<div className='cart_total2 ml-5'>Pickup : $0</div>
							<div className='cart_total2 ml-5'>
								Shipping Charges: $0
							</div>
							<div className='cart_total3'>
								Shipping options will be updated during
								checkout.
							</div>
							<div className='cart_total4'>
								Calculate Shipping
							</div>
							<Row>
								<Col>
									<div className='cart_total ml-3'>Total</div>
								</Col>
								<Col>
									<div className='cart_total1 ml-3'>
										${total()}
									</div>
								</Col>
							</Row>
							<button
								disabled={shoppingCart.length < 1}
								onClick={() => {
									let totalProducts = shoppingCart.map(sc => {
										sc.value =
											sc.value + timeClicked(sc.id);
										return { ...sc };
									});
									let allObjects = {
										products: totalProducts,
										total: totalAfter(),
									};
									localStorage.setItem(
										'checkout',
										JSON.stringify(allObjects)
									);
									history.push('/checkout');
								}}
								className='payment_btn mx-3'
							>
								Proceed to Checkout
							</button>
							<div
								onClick={() => {
									history.push('/shop');
								}}
								className='continue mt-3'
							>
								Continue To Shopping
							</div>
						</Col>
					</Row>
				</Container>
			</div>
			<Footer />
		</>
	);
};

export default ShoppingCart;
